// extracted by mini-css-extract-plugin
module.exports = {"autosuggest-container":"AccountAutosuggest_autosuggest-container__3WCBW"};